/*
 *  Document   : candidate-mission-index.js
 *  Author     : Exapoint
 *
 */

// Import required modules

// Tools


import ExaHelpers from "../exa_helpers";

export default class CandidateMissionIndex {
    /*
    * Auto called when creating a new instance
    *
    */
    constructor() {
        window["CandidateMissionIndex"] = this;
        this.init();
    }

    /*
     * Updates the color theme
     *
     */
    init() {
        // Fix for incorrect body height
        document.querySelector('body').style.height = 'auto';

        $.ajax({
            type: 'GET',
            url: jsVars.missionRequestDatatablesAjax
        }).then(({ data }) => {
            let html
            if (!data || !data.length) {
                html = `<div class="no-data"><p class="text">${jsVars.noMissionLet}</p></div>`;
            } else {
                html = data.map(el => {
                    const hours = { am_to: null, am_from: null, pm_to: null, pm_from: null }
                    let action = '';

                    let latestResponse = el.candidate_responses && el.candidate_responses.length !== 0 ? el.candidate_responses[0] : false;
                    if (!latestResponse) return action;

                    let currType = parseInt(latestResponse.type_id);

                    Object.entries(hours).forEach(([key, _]) => {
                        for (let i in el.mission.working_hours) {
                            if (i.includes(key) && !hours[key]) hours[key] = el.mission.working_hours[i]
                        }
                    })
                    if (el.chat !== null) {
                        action += ` <div> <a  data-createchaturl="${jsVars.createChatUrl}" data-matchid="${el.id}" class="btn btn-small btn-outline-primary border-s btn-block open-chat-window mb-2" id="open-chat-window-${el.id}" href="javascript:void(0);">${jsVars.openChatTxt}</a></div>`;
                    }

                    if (currType === jsVars.invitationResponse) {
                        if (latestResponse.response_at) {
                            action += `<div class="text-center"><span>${jsVars.respondedToInvitationAt} ${ExaHelpers.formatDateTimeWithLocale(new Date(latestResponse.response_at), jsVars.labelBetween)}</span></div>`;
                        } else {
                            action += `
                            <div class="d-flex align-items-center gap-8">
                                <form method="POST" class="w-100" action="${jsVars.declineInvitationUrl.replace(':id', el.match_id).replace(':token', latestResponse.token)}">
                                    <input type="hidden" name="_token" value="${Laravel.csrfToken}">
                                    <button type="submit" class="btn w-100 btn-outline-danger no-min border-s btn-small js-swal-confirm">${jsVars.declineInvitation}</button>
                                </form>
                                <form method="POST" class="w-100" action="${jsVars.acceptInvitationUrl.replace(':id', el.match_id).replace(':token', latestResponse.token)}">
                                    <input type="hidden" name="_token" value="${Laravel.csrfToken}">
                                    <button type="submit" class="btn w-100 no-min border-s btn-small btn-success">${jsVars.acceptInvitation}</button>
                                </form>
                            </div>
                        `;
                        }
                    } else if (currType === jsVars.modificationResponse) {
                        if (latestResponse.response_at) {
                            action += `<div class="text-center"><span>${jsVars.respondedToModificationAt} ${ExaHelpers.formatDateTimeWithLocale(new Date(latestResponse.response_at), jsVars.labelBetween)}</span></div>`;
                        } else {
                            action += `
                            <div class="d-flex align-items-center gap-8">
                                <form method="POST" class="w-100" action="${jsVars.declineModificationUrl.replace(':id', el.match_id).replace(':token', latestResponse.token)}">
                                    <input type="hidden" name="_token" value="${Laravel.csrfToken}">
                                    <button type="submit" class="btn w-100 btn-outline-danger no-min border-s btn-small js-swal-confirm">${jsVars.declineModification}</button>
                                </form>
                                <form method="POST" class="w-100" action="${jsVars.acceptModificationUrl.replace(':id', el.match_id).replace(':token', latestResponse.token)}">
                                    <input type="hidden" name="_token" value="${Laravel.csrfToken}">
                                    <button type="submit" class="btn w-100 btn-success no-min border-s btn-small">${jsVars.acceptModification}</button>
                                </form>
                            </div>
                        `;
                        }
                    } else if (currType === jsVars.confirmationResponse) {
                        if (latestResponse.response_at) {
                            action += `<div class="text-center"><span>${jsVars.respondedToConfirmationAt} ${ExaHelpers.formatDateTimeWithLocale(new Date(latestResponse.response_at), jsVars.labelBetween)}</span></div>`;
                        } else {
                            action += `
                            <div class="d-flex align-items-center gap-8">
                                <form method="POST" class="w-100" action="${jsVars.declineConfirmationUrl.replace(':id', el.match_id).replace(':token', latestResponse.token)}">
                                    <input type="hidden" name="_token" value="${Laravel.csrfToken}">
                                    <button type="submit" class="btn w-100 btn-outline-danger no-min border-s btn-small js-swal-confirm">${jsVars.declineConfirmation}</button>
                                </form>
                                <form method="POST" class="w-100" action="${jsVars.acceptConfirmationUrl.replace(':id', el.match_id).replace(':token', latestResponse.token)}">
                                    <input type="hidden" name="_token" value="${Laravel.csrfToken}">
                                    <button type="submit" class="btn w-100 btn-success no-min border-s btn-small p-0">${jsVars.acceptConfirmation}</button>
                                </form>
                            </div>
                        `;
                        }
                    }



                    // return `<div id="el-${el.id}" class="display-table">${action}</div>`
                    let startDate = new Date(el.mission.start_date);
                    let endDate = new Date(el.mission.end_date);

                    startDate = ExaHelpers.isValidDate(startDate) ? ExaHelpers.formatDateWithLocale(startDate) : '';
                    if (ExaHelpers.isValidDate(endDate)) {
                        if (endDate.getFullYear() === 9999) {
                            endDate = jsVars.noEndDate;
                        } else {
                            endDate = ExaHelpers.formatDateWithLocale(endDate);
                        }
                    } else {
                        endDate = '';
                    }

                    return `
                    <div class="col-12 col-lg-4">
                    <div class="card-mission">
                        <div class="card-mission-title">
                            <h3 class="title-xs font-semiBold mb-3">${el.mission.titre}</h3>
                        </div>
                        <div class="card-mission-content">
                            <div class="mb-2">
                                <span class="text d-block font-semiBold">${jsVars.profession}</span>
                                <span class="text d-block text-secondary">${el.mission.professions}</span>
                            </div>
                            <div class="d-flex align-items-center justify-content-start mb-2 gap-12">
                                <div>
                                    <span class="text d-block font-semiBold">${jsVars.startOfTheMission}</span>
                                    <span class="text d-block text-secondary">${startDate}</span>
                                </div>
                                <div>
                                    <span class="text d-block font-semiBold">${jsVars.endOfTheMission}</span>
                                    <span class="text d-block text-secondary">${endDate}</span>
                                </div>
                            </div>

                            <div class="mb-2">
                                <span class="text d-block font-semiBold">${jsVars.scheduleOfTheMission}</span>
                                <div class="card-mission-times">
                                    <div class="card-mission-times-header">
                                        <div class="card-mission-times-header-morning-afternoon">
                                            <span class="text">${jsVars.morning}</span>
                                        </div>
                                        <div class="card-mission-times-header-morning-afternoon">
                                            <span class="text">${jsVars.afternoon}</span>
                                        </div>
                                    </div>
                                    <div class="card-mission-times-content flex-row justify-content-around row-content py-2">
                                        <div class="card-mission-times-content-morning-afternoon d-flex text-center flex-column">
                                            <span class="text text-secondary">${ hours.am_from ? jsVars.from+hours.am_from+"h" : ''}</span>
                                            <span class="text text-secondary">${ hours.am_to ? jsVars.to+hours.am_to+"h" : ''}</span>
                                        </div>
                                        <div class="card-mission-times-content-morning-afternoon d-flex text-center flex-column">
                                            <span class="text text-secondary">${ hours.pm_from ? jsVars.from+hours.pm_from+"h" : ''}</span>
                                            <span class="text text-secondary">${ hours.pm_to ? jsVars.to+hours.pm_to+"h" : ''}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            ${
                                currType === jsVars.invitationResponse
                                ? `<div class="mb-2">
                                        <span class="text d-block font-semiBold">Wanter</span>
                                        <span class="text d-block text-secondary">${el.mission.contact_person_name}</span>
                                    </div>`
                                : ''
                            }

                            <div class="mb-2">
                                <span class="text d-block font-semiBold">${jsVars.locationOfTheMission}</span>
                                <span class="text d-block text-secondary">${el.mission.address_line_1}</span>
                                ${el.mission.address_line_2 ? `<span class="text d-block text-secondary">${el.mission.address_line_2}</span>` : ''}
                                <span class="text d-block text-secondary">${el.mission.postcode} ${el.mission.city}</span>
                            </div>
                            <a
                                href="#"
                                class="btn btn-outline-primary  border-s btn-block btn-card w-100 mb-2"
                                data-target="#candidate-show-mission-basic-info-modal"
                                data-remote="${jsVars.showMissionInfoUrl.replace(':id', latestResponse.match_id).replace(':token', latestResponse.token)}"
                                data-toggle="modal"
                            >
                                ${jsVars.missionDetails}
                            </a>

                            ${action}
                        </div>
                    </div>
                </div>
                `
                }).join('');
            }
                $('#new_mission_card').append(html)
        })


        let swal = Swal.mixin({
            buttonsStyling: !1,
            customClass: {
                confirmButton: "btn btn-success m-1",
                cancelButton: "btn btn-danger m-1",
                input: "form-control"
            }
        });

        $('form [type="submit"].js-swal-confirm').on('click',
            function (e) {
                e.preventDefault();
                let $form = $(e.target).parents('form');

                swal.fire({
                    title: jsVars.confirmActionTitle,
                    text: jsVars.confirm_delete_text,
                    icon: "warning",
                    showCancelButton: !0,
                    customClass: {confirmButton: "btn btn-danger m-1", cancelButton: "btn btn-secondary m-1"},
                    confirmButtonText: jsVars.confirmButtonText,
                    cancelButtonText: jsVars.cancelButtonText,
                    html: !1,
                    preConfirm: function (e) {
                        return $form.submit();
                    }.bind(this)
                }).then((function (n) {
                    n.value ?
                        swal.fire(jsVars.confirmActionSuccess, '', "success") :
                        "cancel" === n.dismiss
                }))

            }.bind(this)
        );

        $.ajax({
            type: 'GET',
            url: jsVars.activeMissionsDatatablesAjax
        }).then(({ data }) => {
            let html
            if (!data || !data.length) {
                html = `<div class="no-data"><p class="text">${jsVars.noMissionLet}</p></div>`;
            } else {
                html = data.map(el => {
                    const hours = { am_to: null, am_from: null, pm_to: null, pm_from: null }
                    let action = '';

                    Object.entries(hours).forEach(([key, _]) => {
                        for (let i in el.mission.working_hours) {
                            if (i.includes(key) && !hours[key]) hours[key] = el.mission.working_hours[i]
                        }
                    })

                    let latestResponse = el.candidate_responses && el.candidate_responses.length !== 0 ? el.candidate_responses[0] : false;
                    let startDate = new Date(el.mission.start_date);
                    let endDate = new Date(el.mission.end_date);

                    let currType = parseInt(latestResponse.type_id);
                    startDate = ExaHelpers.isValidDate(startDate) ? ExaHelpers.formatDateWithLocale(startDate) : '';
                    if (ExaHelpers.isValidDate(endDate)) {
                        if (endDate.getFullYear() === 9999) {
                            endDate = jsVars.noEndDate;
                        } else {
                            endDate = ExaHelpers.formatDateWithLocale(endDate);
                        }
                    } else {
                        endDate = '';
                    }

                    if (currType === jsVars.invitationResponse) {
                        if (latestResponse.response_at) {
                            action += `<div class="subtext font-w400 text-secondary text-center"><span>${jsVars.respondedToInvitationAt} ${ExaHelpers.formatDateTimeWithLocale(new Date(latestResponse.response_at), jsVars.labelBetween)}</span></div>`;
                        }
                    } else if (currType === jsVars.modificationResponse) {
                        if (latestResponse.response_at) {
                            action += `<div class="subtext font-w400 text-secondary text-center"><span>${jsVars.respondedToModificationAt} ${ExaHelpers.formatDateTimeWithLocale(new Date(latestResponse.response_at), jsVars.labelBetween)}</span></div>`;
                        }
                    } else if (currType === jsVars.confirmationResponse) {
                        if (latestResponse.response_at) {
                            action += `<div class="subtext font-w400 text-secondary text-center"><span>${jsVars.respondedToConfirmationAt} ${ExaHelpers.formatDateTimeWithLocale(new Date(latestResponse.response_at), jsVars.labelBetween)}</span></div>`;
                        }
                    }

                    return `<div class="col-12 col-lg-4">
                    <div class="card-mission">
                        <div class="card-mission-title">
                            <h3 class="title-xs font-semiBold mb-3">${el.mission.titre}</h3>
                        </div>
                        <div class="card-mission-content">
                            <div class="mb-2">
                                <span class="text d-block font-semiBold">${jsVars.profession}</span>
                                <span class="text d-block text-secondary">${el.mission.professions}</span>
                            </div>
                            <div class="d-flex align-items-center justify-content-start mb-2 gap-12">
                                <div>
                                    <span class="text d-block font-semiBold">${jsVars.startOfTheMission}</span>
                                    <span class="text d-block text-secondary">${startDate}</span>
                                </div>
                                <div>
                                    <span class="text d-block font-semiBold">${jsVars.endOfTheMission}</span>
                                    <span class="text d-block text-secondary">${endDate}</span>
                                </div>
                            </div>

                            <div class="mb-2">
                                <span class="text d-block font-semiBold">${jsVars.scheduleOfTheMission}</span>
                                <div class="card-mission-times">
                                    <div class="card-mission-times-header">
                                        <div class="card-mission-times-header-morning-afternoon">
                                            <span class="text">${jsVars.morning}</span>
                                        </div>
                                        <div class="card-mission-times-header-morning-afternoon">
                                            <span class="text">${jsVars.afternoon}</span>
                                        </div>
                                    </div>
                                    <div class="card-mission-times-content flex-row justify-content-around row-content py-2">
                                        <div class="card-mission-times-content-morning-afternoon d-flex text-center flex-column">
                                            <span class="text text-secondary">${ hours.am_from ? jsVars.from+hours.am_from+"h" : ''}</span>
                                            <span class="text text-secondary">${ hours.am_to ? jsVars.to+hours.am_to+"h" : ''}</span>
                                        </div>
                                        <div class="card-mission-times-content-morning-afternoon d-flex text-center flex-column">
                                            <span class="text text-secondary">${ hours.pm_from ? jsVars.from+hours.pm_from+"h" : ''}</span>
                                            <span class="text text-secondary">${ hours.pm_to ? jsVars.to+hours.pm_to+"h" : ''}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="mb-2">
                                <span class="text d-block font-semiBold">Wanter</span>
                                <span class="text d-block text-secondary">${el.mission.contact_person_name}</span>
                            </div>

                            <div class="mb-2">
                                <span class="text d-block font-semiBold">${jsVars.locationOfTheMission}</span>
                                <span class="text d-block text-secondary">${el.mission.address_line_1}</span>
                                ${el.mission.address_line_2 ? `<span class="text d-block text-secondary">${el.mission.address_line_2}</span>` : ''}
                                <span class="text d-block text-secondary">${el.mission.postcode} ${el.mission.city}</span>
                            </div>
                            <a
                                href="#"
                                class="btn  w-100 btn-outline-primary no-min border-s btn-small mb-2"
                                data-target="#candidate-show-mission-basic-info-modal"
                                data-remote="${jsVars.showMissionInfoUrl.replace(':id', latestResponse.match_id).replace(':token', latestResponse.token)}"
                                data-toggle="modal"
                            >
                                ${jsVars.missionDetails}
                            </a>
                            ${action}
                        </div>
                    </div>
                </div>
                `}).join('');
            }
            $('#active_missions_card').append(html)
        })

        $.ajax({
            type: 'GET',
            url: jsVars.archivedMissionsDatatablesAjax
        }).then(({ data }) => {
            let html
            if (!data || !data.length) {
                html = `<div class="no-data"><p class="text">${jsVars.noMissionLet}</p></div>`;
            } else {
                html = data.map(el => {
                    const hours = { am_to: null, am_from: null, pm_to: null, pm_from: null }

                    Object.entries(hours).forEach(([key, _]) => {
                        for (let i in el.mission.working_hours) {
                            if (i.includes(key) && !hours[key]) hours[key] = el.mission.working_hours[i]
                        }
                    })

                    let latestResponse = el.candidate_responses && el.candidate_responses.length !== 0 ? el.candidate_responses[0] : false;
                    let currType = parseInt(latestResponse.type_id);

                    let startDate = new Date(el.mission.start_date);
                    let endDate = new Date(el.mission.end_date);

                    startDate = ExaHelpers.isValidDate(startDate) ? ExaHelpers.formatDateWithLocale(startDate) : '';
                    if (ExaHelpers.isValidDate(endDate)) {
                        if (endDate.getFullYear() === 9999) {
                            endDate = jsVars.noEndDate;
                        } else {
                            endDate = ExaHelpers.formatDateWithLocale(endDate);
                        }
                    } else {
                        endDate = '';
                    }

                    let ratingOfMe, ratingILeft;

                    $.each(el.mission.ratings, function (_i, rating) {
                        // if (parseInt(rating.user_id) === jsVars.myUserId) {
                        //     if (rating.total) {
                        //         ratingOfMe = `${jsVars.ratingOfMe}: ${ExaHelpers.ratingToIcons(rating.total)}`;
                        //     }
                        // } else {
                        //     if (rating && !rating.total) {
                        //         ratingILeft = `
                        //         <a href="#" class="btn btn-block btn-primary btn-small mt-2" data-target="#candidate-show-mission-basic-info-modal"
                        //         data-remote="${jsVars.rateUserUrl.replace(':id', rating.mission_id).replace(':token', rating.token)}"
                        //         data-toggle="modal">
                        //         ${jsVars.rateClient}
                        //     </a>`;
                        //     } else if (rating && rating.total) {
                        //         ratingILeft = `${jsVars.rating}: ${ExaHelpers.ratingToIcons(rating.total)}`;
                        //     }
                        // }
                        if (parseInt(rating.user_id) !== jsVars.myUserId) {
                            if (rating && !rating.total) {
                                ratingILeft = `
                                <a href="#" class="btn btn-block btn-primary btn-small mt-2" data-target="#candidate-show-mission-basic-info-modal"
                                data-remote="${jsVars.rateUserUrl.replace(':id', rating.mission_id).replace(':token', rating.token)}"
                                data-toggle="modal">
                                ${jsVars.rateClient}
                            </a>`;
                            } else if (rating && rating.total) {
                                ratingILeft = `${jsVars.rating}: ${ExaHelpers.ratingToIcons(rating.total)}`;
                            }
                        }
                    });

                    let action = `<div class="rating-pair-container">${[ratingOfMe, ratingILeft].filter(Boolean).join("<br>")}</div>`;

                    return `
                    <div class="col-12 col-lg-4">
                        <div class="card-mission">
                            <div class="card-mission-title">
                                <h3 class="title-xs font-semiBold mb-3">${el.mission.titre}</h3>
                            </div>
                            <div class="card-mission-content">
                                <div class="mb-2">
                                    <span class="text d-block font-semiBold">${jsVars.profession}</span>
                                    <span class="text d-block text-secondary">${el.mission.professions}</span>
                                </div>
                                <div class="d-flex align-items-center justify-content-start mb-2 gap-12">
                                    <div>
                                        <span class="text d-block font-semiBold">${jsVars.startOfTheMission}</span>
                                        <span class="text d-block text-secondary">${startDate}</span>
                                    </div>
                                    <div>
                                        <span class="text d-block font-semiBold">${jsVars.endOfTheMission}</span>
                                        <span class="text d-block text-secondary">${endDate}</span>
                                    </div>
                                </div>


                                <div class="mb-2">
                                    <span class="text d-block font-semiBold">${jsVars.scheduleOfTheMission}</span>
                                    <div class="card-mission-times">
                                        <div class="card-mission-times-header">
                                            <div class="card-mission-times-header-morning-afternoon">
                                                <span class="text">${jsVars.morning}</span>
                                            </div>
                                            <div class="card-mission-times-header-morning-afternoon">
                                                <span class="text">${jsVars.afternoon}</span>
                                            </div>
                                        </div>
                                        <div class="card-mission-times-content flex-row justify-content-around row-content py-2">
                                            <div class="card-mission-times-content-morning-afternoon d-flex text-center flex-column">
                                                <span class="text text-secondary">${ hours.am_from ? jsVars.from+hours.am_from+"h" : ''}</span>
                                                <span class="text text-secondary">${ hours.am_to ? jsVars.to+hours.am_to+'h' : ''}</span>
                                            </div>
                                            <div class="card-mission-times-content-morning-afternoon d-flex text-center flex-column">
                                                <span class="text text-secondary">${ hours.pm_from ? jsVars.from+hours.pm_from+'h' : ''}</span>
                                                <span class="text text-secondary">${ hours.pm_to ? jsVars.to+hours.pm_to+'h' : ''}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="mb-2">
                                    <span class="text d-block font-semiBold">Wanter</span>
                                    <span class="text d-block text-secondary">${el.mission.contact_person_name}</span>
                                </div>


                                <div class="mb-2">
                                    <span class="text d-block font-semiBold">Lieu de la mission</span>
                                    <span class="text d-block text-secondary">${el.mission.address_line_1}</span>
                                    ${el.mission.address_line_2 ? `<span class="text d-block text-secondary">${el.mission.address_line_2}</span>` : ''}
                                    <span class="text d-block text-secondary">${el.mission.postcode} ${el.mission.city}</span>
                                </div>

                                <!-- <a
                                    href="#"
                                    class="btn  w-100 btn-outline-primary no-min border-s btn-small mb-2"
                                    data-target="#candidate-show-mission-basic-info-modal"
                                    data-remote="${jsVars.showMissionInfoUrl.replace(':id', latestResponse.match_id).replace(':token', latestResponse.token)}"
                                    data-toggle="modal"
                                >
                                    ${jsVars.missionDetails}
                                </a> -->

                                ${action}
                            </div>
                        </div>
                    </div>`
                }).join('');
            }

            $('#archived_missions_card').append(html)
        })

        window.addEventListener('message', function (message) {
            if (message.data.type === 'iframe.redirect_requested') {
                window.location = message.data.redirectTo;
            }
        });

        let $editUserModal = $('#candidate-show-mission-basic-info-modal');
        $editUserModal.on('show.bs.modal', function (e) {
            ExaHelpers.loadIframeInModal(e);
        });
    }

}

